(() => {
  const VALA = window.VALA;

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enabled === 'false') return;
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-predictive-search]');
      if (!this.input || !this.results) return;
      this.abortController = null;
      this.timer = null;
      this.input.addEventListener('input', () => this.onInput());
      this.input.addEventListener('focus', () => {
        if (this.input.value.trim().length >= 2 && this.results.innerHTML.trim()) this.open();
      });
      this.addEventListener('keydown', (event) => this.onKeydown(event));
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.close();
      });
    }

    onInput() {
      window.clearTimeout(this.timer);
      const term = this.input.value.trim();
      if (term.length < 2) {
        this.close();
        return;
      }
      this.timer = window.setTimeout(() => this.fetchResults(term), 250);
    }

    async fetchResults(term) {
      this.abortController?.abort();
      this.abortController = new AbortController();
      this.classList.add('is-loading');
      const parameters = new URLSearchParams({
        q: term,
        'resources[type]': 'product,page,article',
        'resources[limit]': this.dataset.limit || '6',
        'resources[options][unavailable_products]': 'last',
        section_id: 'predictive-search'
      });
      try {
        const response = await fetch(`${VALA.routes.predictiveSearch}?${parameters.toString()}`, {
          signal: this.abortController.signal,
          headers: { Accept: 'text/html' }
        });
        if (!response.ok) throw new Error(String(response.status));
        const text = await response.text();
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const source = parsed.getElementById('PredictiveSearchResults');
        this.results.innerHTML = source ? source.outerHTML : '';
        this.open();
      } catch (error) {
        if (error.name !== 'AbortError') this.close();
      } finally {
        this.classList.remove('is-loading');
      }
    }

    open() {
      this.results.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.results.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
        this.input.focus();
        return;
      }
      if (!['ArrowDown', 'ArrowUp'].includes(event.key) || this.results.hidden) return;
      const links = Array.from(this.results.querySelectorAll('a'));
      if (!links.length) return;
      event.preventDefault();
      const index = links.indexOf(document.activeElement);
      const next = event.key === 'ArrowDown'
        ? links[(index + 1) % links.length]
        : links[(index - 1 + links.length) % links.length];
      next.focus();
    }
  }

  if (!customElements.get('predictive-search')) customElements.define('predictive-search', PredictiveSearch);
})();
